import auth from '../../../config/app-specific-config/auth';
import * as types from './auth-integrations-action-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { getUserProfile } from '../../profile/actions/users-profile-actions';
import { setUserPrivileges } from './auth-actions';
import { sendFeErrorMessage } from '../../global/actions/fe-error-notification-actions';


// Signup through external integrations actions
function integrationSignupRequest() {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_REQUEST
	};
}

function integrationSignupSuccess(response) {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_SUCCESS,
		payload: response
	};
}

function integrationSignupFailure(integrationSignupFailureResponse) {
	return {
		type: types.MANAGE_3P_INTEGRATION_SIGNUP_FAILURE,
		payload: integrationSignupFailureResponse
	};
}

export function manage3pIntegrationSignup(integrationSignupPayload) {
	return async dispatch => {
		dispatch(integrationSignupRequest());
		try {
			const header = auth.getContentType();
			const response = await axiosInstance.post('/users/integrations', integrationSignupPayload, header);

			if (response.data.data.eventProcessed) {
				switch (response.data.data.eventProcessed) {
					case ("login-existing-3p-integration-user"): {
						const { nextEvent, userSession, userPrivileges } = response.data.data || {};

						if (nextEvent === "login-existing-user") {
							const { token, user, userType } = userSession || {};
							const { idToken } = user || {};

							if (userPrivileges) {
								dispatch(setUserPrivileges(userPrivileges))
							}

							if (token) {
								auth.storeToken(token);
								userType && localStorage.setItem('USER_CATG', userType);
								idToken && localStorage.setItem('USER_ID_TOKEN', idToken);
								dispatch(getUserProfile({
									getUserInfo: true,
									getUserOrgInfo: true,
									getUserMetaData: true
								})); // review scopes
							} else {
								// TODO: Internal message sent, but consider showing error UI also

								dispatch(sendFeErrorMessage({
									userIdToken: idToken || "",
									errorCode: "DT2MMC",
									errorMessage: "Unable to login existing user trying to integrate 3P service",
									internalNotes: "Check on Zoom (currently the only 3P service)",
									errorReportMetadata: {
										integrationSignupPayload,
										nextEvent, userSession, userPrivileges
									}
								}))

							}

						} else if (nextEvent === "show-login-error") {
							// TODO: Internal message sent, but consider showing error UI also

							dispatch(sendFeErrorMessage({
								userIdToken: "N/A",
								errorCode: "QVVH39",
								errorMessage: "Unable to show login error",
								internalNotes: "No user id since unable to login. Most likely a UI FE issue but also check on Zoom (currently the only 3P service)",
								errorReportMetadata: {
									integrationSignupPayload,
									nextEvent, userSession, userPrivileges
								}
							}))

						}
						break;
					}
					case ("create-3p-integration-user-account"): {
						const { nextEvent, userSession, userPrivileges } = response.data.data || {};

						if (nextEvent === "login-created-user") {
							const { token, user, userType } = userSession || {};
							const { idToken } = user || {};

							if (userPrivileges) {
								dispatch(setUserPrivileges(userPrivileges))
							}

							if (token) {
								auth.storeToken(token);
								userType && localStorage.setItem('USER_CATG', userType);
								idToken && localStorage.setItem('USER_ID_TOKEN', idToken);
								dispatch(getUserProfile({
									getUserInfo: true,
									getUserOrgInfo: true,
									getUserMetaData: true
								})); // Review scopes
							} else {
								// TODO: Consider showing UI for errors for UX purposes
								dispatch(sendFeErrorMessage({
									userIdToken: idToken || "N/A",
									errorCode: "J63WZZ",
									errorMessage: "Unable to login 3P integration created new user",
									internalNotes: "Check on Zoom (currently the only 3P service)",
									errorReportMetadata: {
										integrationSignupPayload,
										nextEvent, userSession, userPrivileges
									}
								}))
							}
						} else if (nextEvent === "show-unsuccessful-create-user-outcome") {
							// TODO: Consider showing UI for errors for UX purposes
							dispatch(sendFeErrorMessage({
								userIdToken: "N/A",
								errorCode: "A66U53",
								errorMessage: "Unable to create new LD user for login 3P integration situation",
								internalNotes: "Check on Zoom (currently the only 3P service)",
								errorReportMetadata: {
									integrationSignupPayload,
									nextEvent, userSession, userPrivileges
								}
							}))
						}

						break;
					}
					default: {

						break;
					}
				}
			}


			dispatch(integrationSignupSuccess(response.data.data));
		} catch (error) {

			if (error.message === 'Request failed with status code 500') {
				const integrationSignupFailureResponse = {
					integrationSignupError: true,
					type: 'Account already exists',
					message: 'You may have registered for an account with this email address.'
				}
				dispatch(integrationSignupFailure(integrationSignupFailureResponse));

			} else if (error.message === 'Network Error') {
				const integrationSignupFailureResponse = {
					integrationSignupError: true,
					type: 'Network Error',
					message: 'Network connectivity issues detected. Please check your internet connection, and try again later.'
				}
				dispatch(integrationSignupFailure(integrationSignupFailureResponse));

			}
		}
	}
}